import ContentStorage, { ComponentKeys } from '../tnew/content/ContentStorage';

function getValue(name: string) {
  return ContentStorage.getValue(ComponentKeys.UTILITY_NAVIGATION, name);
}

class UtilityNavigationComponent {
  static get promoCodeEntrySubhead() {
    return getValue('PromoCodeEntrySubhead');
  }
}

export default UtilityNavigationComponent;
